import { render } from "./SignItemWrap.vue?vue&type=template&id=f60b2028&scoped=true"
import script from "./SignItemWrap.vue?vue&type=script&lang=js"
export * from "./SignItemWrap.vue?vue&type=script&lang=js"

import "./SignItemWrap.vue?vue&type=style&index=0&id=f60b2028&lang=stylus"
import "./SignItemWrap.vue?vue&type=style&index=1&id=f60b2028&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60b2028"]])

export default __exports__